import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from '@app/services/Alert/alert.service';
import { UserService } from '@app/services/User/user.service';
import { ToastrService } from 'ngx-toastr';

import { User } from '@app/model/user';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import Swiper from 'swiper';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  forgotForm!: FormGroup;

  //For toggle modal
  addRemoveClass: boolean = false;
  clickEvent() {
    this.addRemoveClass = !this.addRemoveClass;
  }

  //For Alert
  private subscription!: Subscription;
  alert: any;
  
  // Password view
  fieldTextType: boolean = false;
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private router: Router,
    private alertService: AlertService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.swiper();

    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'), Validators.minLength(6)])],
    });

    this.forgotForm = this.formBuilder.group({
      fEmail: ['', Validators.compose([Validators.required, Validators.email])],
    });

    // For Alert
    this.subscription = this.alertService.onAlert()
      .subscribe(alert => {
        switch (alert?.type) {
          case 'success':
            alert.cssClass = 'alert alert-success';
            break;
          case 'error':
            alert.cssClass = 'alert alert-danger';
            break;
        }

        this.alert = alert;
        //setTimeout(() => {
        //  this.alert.cssClass = 'hide';
        //}, 1000);
      });
  }

  get email() { return this.loginForm.controls['email']; }
  get password() { return this.loginForm.controls['password']; }
  get fEmail() { return this.forgotForm.controls['fEmail']; }

  loginUser() {
    const { email, password } = this.loginForm.value;
    this.userService.login(email, password).subscribe({
      next: (res: any) => {
        if (res.success !== 0 && res.token !== null) {
          Swal.fire({
            title: "Login successful",
            icon: "success",
            showConfirmButton: false,
            timer: 1000
          });
          window.location.href = 'dashboard';
          // this.router.navigate(['dashboard']);
        } else {
          Swal.fire({
            title: res.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500
          });

          this.alertService.error(res.message);
        }
      },
      error: (err: any) => {
        //console.log(err)
        Swal.fire({
          title:  err,
          icon: "error",
          showConfirmButton: false,
          timer: 2000
        });
        // this.alertService.error("Hello, Email or password is wrong!");
        // this.toastr.error('Email or password is wrong!', 'Hello ' + email, {
        //   timeOut: 5000,
        // });
      }
    }
    )
  }

  forgotPassword() {
    const { fEmail } = this.forgotForm.value;
    this.userService.forgotPassword(fEmail).subscribe(
      {
        next: (res: any) => {
          if (res.success !== 0) {
            Swal.fire({
              title: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1000
            });
            this.addRemoveClass = false;
            this.alertService.success('Please check your email for a new password.', true);
            //this.toastr.success('Please check your email for a new password.', 'Hello');
          } else {
            Swal.fire({
              title: res.message,
              icon: "error",
              showConfirmButton: false,
              timer: 1500
            });

            //this.alertService.error(res.message);
            //this.toastr.error(res.message, 'Hello ' + fEmail, {
            //  timeOut: 5000,
            //});
          }
        },
        error: (err: any) => {
          console.log(err)
        }
      }
    )
  }

  onClickNavigation(route: string) {
    this.router.navigate([route])
  }

  //Swiper
  swiper() {
    new Swiper(".mySwiper_photo", {
      spaceBetween: 30,
      effect: "fade",
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
      }
    }); 
  }
}
